// removed by extract-text-webpack-plugin
module.exports = {"caption":"caption__caption___12BMm","text":"caption__text___1bM5C"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Object/Slider/Caption/caption.scss
// module id = 931
// module chunks = 0